import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { RecoveryCodeService } from '../../recovery-code.service';
import { UserStateService } from '../../user-state.service';
import { LoadingService } from '../../loading.service';

@Component({
  selector: 'app-recovery-code-generator',
  templateUrl: './recovery-code-generator.component.html',
  styleUrls: ['./recovery-code-generator.component.scss'],
})
export class RecoveryCodeGeneratorComponent implements OnInit {
  @Input() showModal = false;
  @Output() onClose = new EventEmitter<void>();

  recoveryCode: string | null = null;
  loading = false;
  error: string | null = null;
  success = false;
  copied = false;

  constructor(
    private recoveryCodeService: RecoveryCodeService,
    private userStateService: UserStateService,
    private loadingService: LoadingService
  ) {}

  ngOnInit(): void {
    // Check if recovery code already exists in localStorage/state
    const userState = this.userStateService.getCurrentUserState();
    if (userState.recoveryCode) {
      this.recoveryCode = userState.recoveryCode;
    }
  }

  async generateRecoveryCode(): Promise<void> {
    this.loading = true;
    this.error = null;
    this.success = false;
    this.loadingService.startLoading();

    try {
      const userState = this.userStateService.getCurrentUserState();
      // Only pass userId for anonymous users
      const response = await this.recoveryCodeService.generateRecoveryCode(
        !userState.isAuthenticated ? userState.userId || undefined : undefined
      );

      this.recoveryCode = response.recoveryCode;
      if (this.recoveryCode) {
        this.userStateService.setRecoveryCode(this.recoveryCode);
      }
      this.success = true;
    } catch (error: any) {
      console.error('Failed to generate recovery code', error);
      
      if (error.status === 409) {
        this.error = 'Recovery code already generated. Use existing code.';
        // Try to load existing code
        try {
          const userState = this.userStateService.getCurrentUserState();
          this.recoveryCode = userState.recoveryCode;
        } catch (e) {
          this.error = 'Failed to generate recovery code';
        }
      } else {
        this.error = 'Failed to generate recovery code. Please try again.';
      }
    } finally {
      this.loading = false;
      this.loadingService.stopLoading();
    }
  }

  copyToClipboard(): void {
    if (this.recoveryCode) {
      navigator.clipboard.writeText(this.recoveryCode).then(() => {
        this.copied = true;
        setTimeout(() => {
          this.copied = false;
        }, 2000);
      });
    }
  }

  closeModal(): void {
    this.onClose.emit();
  }
}
